import { fetch, TypedResponse } from '@lower-financial/toolbox';
import { MortgageRateDto } from '@lower-financial/lending-web-api/generated';
import { ENV } from '@lightspeed/environment';

export default function todaysRates(lenderName = 'lower') {
  return fetch<TypedResponse<Required<MortgageRateDto>[]>>(`${ENV.BACKEND_API_HOST}/api/lending/mortgage_rates/lender/${lenderName}`);
}
